import { render, staticRenderFns } from "./DateMeal.vue?vue&type=template&id=5c3c9a9c&"
import script from "./DateMeal.vue?vue&type=script&lang=js&"
export * from "./DateMeal.vue?vue&type=script&lang=js&"
import style0 from "./DateMeal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports